export default "__VITE_ASSET__BOtRGuO0__"